import React from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { withApp } from '@brainstud/react-tbl/themes/pgw/v1/helpers'
import { selectNavigation } from './selectors'
// import { setProgress as setChapterProgress } from '@brainstud/react-tbl/features/chapters/store/actions'
import { setProgress as setNavigationProgress } from '@brainstud/react-tbl/features/navigation/store/actions'

const withEndtest = Component => props => {
  const { dispatch, staticContext, ...rest } = props

  return <Component {...rest} />
}

const mapProps = (state, props) => {
  const endtest = {
    intro: {
      type: 'page',
    }
  }
  const navigation = selectNavigation(state, props, true)
  const navigationItem = navigation.find(item => item.type === 'endtest')

  return { endtest, navigation: navigationItem }
}

const mapActions = (dispatch) => {
  return {
    // setChapterProgress: params => dispatch(setChapterProgress(params)),
    setNavigationProgress: params => dispatch(setNavigationProgress(params)),
  }
}

export default compose(
  connect(mapProps, mapActions),
  withApp,
  withEndtest,
)

// export default withRouter(withApp(connect(
//   (state, props) => ({
//     endtest: state.account.endtest,
//     navigation: state.content.navigation,
//     progress: state.account.progress,
//   }),
//   (dispatch) => ({
//     accountActions: bindActionCreators(accountActions, dispatch)
//   })
// )(EndtestQuestionView)))

// export default withRouter(withApp(connect(
//   (state, props) => ({
//     endtest: {
//       intro: {
//         type: 'page',
//       }
//     },
//     navigation: state.content.navigation,
//   }),
//   (dispatch) => ({})
// )(EndtestIntroView)))
